import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Editable from './Editable';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-mark.png?v=3" alt="Mac Guru" className="w-6 h-6 object-contain" />
              <span className="text-lg font-semibold">Mac Guru</span>
            </div>
            <p className="text-sm text-[#A1A1AA] leading-relaxed">
              <Editable contentKey="footer.tagline" fallback="Your trusted destination for premium Apple products and expert repair services in Pakistan." multiline />
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wider"><Editable contentKey="footer.quicklinks.title" fallback="Quick Links" /></h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                Home
              </Link>
              <Link to="/products" className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                Products
              </Link>
              <Link to="/repairs" className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                Repairs
              </Link>
              <Link to="/contact" className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wider"><Editable contentKey="footer.services.title" fallback="Services" /></h3>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-[#A1A1AA]"><Editable contentKey="footer.service1" fallback="MacBook Sales" /></p>
              <p className="text-sm text-[#A1A1AA]"><Editable contentKey="footer.service2" fallback="Screen Replacement" /></p>
              <p className="text-sm text-[#A1A1AA]"><Editable contentKey="footer.service3" fallback="Battery Replacement" /></p>
              <p className="text-sm text-[#A1A1AA]"><Editable contentKey="footer.service4" fallback="Logic Board Repair" /></p>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wider"><Editable contentKey="footer.contact.title" fallback="Contact" /></h3>
            <div className="flex flex-col gap-3">
              <a href="tel:+923006686206" className="flex items-center gap-2 text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                <Phone className="w-4 h-4" strokeWidth={1.5} />
                +92 0300 6686206
              </a>
              <a href="mailto:macguru911@gmail.com" className="flex items-center gap-2 text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300">
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                macguru911@gmail.com
              </a>
              <div className="flex items-start gap-2 text-sm text-[#A1A1AA]">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>P34, near Rex City, Peoples Colony No.1, Faisalabad, 38000, Pakistan</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-center text-sm text-[#A1A1AA]">
            © {new Date().getFullYear()} Mac Guru. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};